// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"158":"labels","496":"campaigns","644":"account","721":"inbox","806":"user"}[chunkId] + "." + {"158":"08a2d6a65be9394e71bd","496":"6866f28a7521ff0248d7","644":"80fcd4ab13ac359bdf7f","721":"c816712a21d994371666","806":"65a2868f3029a26f9fc0"}[chunkId] + ".js";
};